import(/* webpackMode: "eager", webpackExports: ["ClientPage"] */ "/tmp/seed/source/app/(normal)/recover-password/client.page.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/app/(normal)/recover-password/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Flex/Flex.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Image/Image.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
